export default "__VITE_ASSET__BCwdMJhl__"